import React from 'react'
import PropTypes from 'prop-types'
import { Box, Typography, Link } from '@mui/material'

const fmt = (n) => n != null ? `$ ${Number(n).toLocaleString('en-US', { minimumFractionDigits: 2 })}` : '—'

function SummaryRow({ label, openVal, totalVal, isLink }) {
  return (
    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', py: 0.4 }}>
      <Typography sx={{ fontSize: '0.82rem', fontFamily: 'AtlasGroteskRegular', color: '#262626', fontWeight: 600 }}>
        {label}
      </Typography>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
        {isLink ? (
          <Link href='#' underline='hover' sx={{ fontSize: '0.82rem', fontFamily: 'AtlasGroteskRegular', color: '#1a8a6a' }}>
            {openVal}
          </Link>
        ) : (
          <>
            <Typography sx={{ fontSize: '0.82rem', fontFamily: 'AtlasGroteskRegular', color: '#262626', textAlign: 'right', minWidth: 60 }}>
              {openVal}
            </Typography>
            {totalVal !== undefined && (
              <>
                <Typography sx={{ fontSize: '0.82rem', fontFamily: 'AtlasGroteskRegular', color: '#bbb', mx: 0.25 }}>/</Typography>
                <Typography sx={{ fontSize: '0.82rem', fontFamily: 'AtlasGroteskRegular', color: '#262626', textAlign: 'right', minWidth: 60 }}>
                  {totalVal}
                </Typography>
              </>
            )}
          </>
        )}
      </Box>
    </Box>
  )
}
SummaryRow.propTypes = {
  label: PropTypes.string.isRequired,
  openVal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  totalVal: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  isLink: PropTypes.bool,
}

function OrderSummaryCardV2({ orderDetail }) {
  if (!orderDetail) return null

  const holds = orderDetail.holds || []
  const lines = orderDetail.lines || []

  const openHolds = holds.filter((h) => !h.released)
  const orderHoldsOpen = openHolds.filter((h) => h.appliedTo === 'ORDER').length
  const orderHoldsTotal = holds.filter((h) => h.appliedTo === 'ORDER').length
  const lineHoldsOpen = openHolds.filter((h) => h.appliedTo === 'LINE').length
  const lineHoldsTotal = holds.filter((h) => h.appliedTo === 'LINE').length

  const openLines = lines.filter((l) => l.openQty > 0).length
  const totalLines = lines.length
  const openQty = lines.reduce((s, l) => s + l.openQty, 0)
  const totalQty = lines.reduce((s, l) => s + l.totalQty, 0)
  const openValue = lines.reduce((s, l) => s + l.openQty * l.unitPrice, 0)
  const totalValue = lines.reduce((s, l) => s + l.totalQty * l.unitPrice, 0)

  return (
    <Box sx={{
      border: '1px solid #e7e7e7',
      borderRadius: 2,
      p: 2.5,
      backgroundColor: '#fff',
      height: '100%',
    }}>
      <Typography sx={{ fontFamily: 'SanomatMedium', fontSize: '0.95rem', color: '#262626', fontWeight: 700, mb: 2 }}>
        Order Summary (Open / Total)
      </Typography>
      <SummaryRow label='Value' openVal={fmt(openValue)} totalVal={fmt(totalValue)} />
      <SummaryRow label='Lines' openVal={openLines} totalVal={totalLines} />
      <SummaryRow label='Quantity' openVal={openQty} totalVal={totalQty} />
      <SummaryRow label='Order Holds' openVal={orderHoldsOpen} totalVal={orderHoldsTotal} />
      <SummaryRow label='Line Holds' openVal={lineHoldsOpen} totalVal={lineHoldsTotal} />
      <SummaryRow label='Shipments (PPS)' openVal={orderDetail.ppsCount ?? 0} isLink />
    </Box>
  )
}

OrderSummaryCardV2.propTypes = { orderDetail: PropTypes.object }

export default OrderSummaryCardV2
